import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { hideModal, resetModal } from 'redux/modules/modal';
import { List, ListItem } from '@material-ui/core';
import ERRORS from '../../errors/errorids';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { XIcon, SpinnerIcon } from '../../theme/icons';
import {
	trackConfirmPurchaseChoicePopupShown
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const styles = theme => {
	return {
		/* Dialog */
		dialogPaper: {
			minWidth: 444
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px 15px',
			minHeight: 291
		},
		dialogTitle: {
			'& h6': {
				fontWeight: 600,
				fontSize: '28px',
				lineHeight: 1.4,
				marginBottom: 6,
				textAlign: 'left'
			}
		},
		/* close button */
		closeDialog: {
			position: 'absolute',
			top: 10,
			right: 10
		},
		closeDialogIcon: {
			color: '#6F99BD',
			width: '20px',
			height: '20px'
		},
		/* buttons */
		button: {
			fontFamily: 'Open Sans, sans-serif',
			borderRadius: 5,
			fontWeight: 600,
			fontSize: 18,
			lineHeight: 1.3,
			color: '#000',
			opacity: '1 !important',
			paddingLeft: 15,
			paddingRight: 15,
			minWidth: 'auto'
		},
		buttonCancel: {
		},
		buttonPrimary: {
			background: theme.palette.primary.main,
			color: 'white',
			textShadow: 'none',
			'&[class*=contained][class*=disabled]': {
				backgroundColor: '#B3B9C0'
			}
		},
		buttonContinue: {
			marginLeft: 10
		},
		/* description and list items */ 
		selectedItemsDescription: {
			opacity: 1,
			color: '#000',
			textAlign: 'left',
			margin: '0 0 10px'
		},
		selectedItemsList: {
			margin: '0 0 30px 10px',
			listStyle: 'none'
		},
		selectedItemsListItem: {
			textAlign: 'left',
			fontSize: 16,
			lineHeight: 1.5,
			color: '#000',
			fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
			position: 'relative',
			padding: '0 0 0 14px',
			'&:before': {
				content: '""',
				display: 'inline-block',
				width: '3px',
				height: '3px',
				borderRadius: 3,
				background: '#000',
				marginRight: 5,
				position: 'absolute',
				top: 10,
				left: 0
			},
		},
		/* error message */
		errorMessage:  {
			color: theme.palette.error.main,
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1,
			textAlign: 'left',
			marginTop: 0,
			marginBottom: 15,
			'& a': {
				color: theme.palette.primary.main
			}
		},
		/* loading icon */
		loadingWrapper: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		loadingMessage: {
			fontSize: 16,
			lineHeight: 1.5,
			opacity: 1
		},
		loadingIcon: {
			display: 'block',
			height: '24px',
			width: '24px',
			margin: '0 auto 10px',
			fill: '#96DCFD',
			animation: 'spin 2s linear infinite'
		},
		'@keyframes spin': {
			'0': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		}		
	};
};

const errors = {
	[ERRORS.OFFLINE] : localize('subscriptions-error-offline'),
	[ERRORS.API_REQUEST_LIMIT_EXCEEDED] : localize('error-cb-api-rate-limit-reached'),
	[ERRORS.THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY]: 
		localize('subscriptions-error-invalid-numbers-of-users')
};

@withStyles(styles)
class ConfirmPurchaseChoiceModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			apiRequestError: false,
			apiRequestSuccess: false,
			xhrInProgress: false,
			errors: {}
		};		
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.companies.createChargeBeeSubscriptionErrorId !== nextProps.companies.createChargeBeeSubscriptionErrorId &&
			nextProps.companies.createChargeBeeSubscriptionErrorId !== null) {
			this.handleApiErrors(nextProps);
		}

		if (this.props.companies.createChargeBeeSubscriptionSuccess !== nextProps.companies.createChargeBeeSubscriptionSuccess &&
			nextProps.companies.createChargeBeeSubscriptionSuccess === true) {
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: true,
				errors: { apiError: null }
			});			
		}		
	}

	componentDidMount() {
		trackConfirmPurchaseChoicePopupShown(this.props.plan, getTrackingOptions(this.props.company));
	}	

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					<IconButton
						className={classes.closeDialog}
						component='span'
						aria-label='Close'
						onClick={() => this.closeDialog()}
					>
						<XIcon className={classes.closeDialogIcon} />

					</IconButton>
					{(() => {
						if (this.state.xhrInProgress) {
							return this.renderLoading();
						} else if (this.state.apiRequestSuccess) {
							this.closeDialog();							
						} else if (this.state.apiRequestError) {
							return this.renderContent();
						} else {
							return this.renderContent();
						}
					})()}
				</div>
			</Dialog>
		);
	}

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingWrapper}>
				<SpinnerIcon className={classes.loadingIcon} />
				<Typography className={classes.loadingMessage} variant="body2">
					{localize('subscriptions-modal-fetching-data')}
				</Typography>
			</div>
		);
	}	

	renderContent() {
		const { classes, listItems } = this.props;

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>{localize('subscription-confirm-choice-title')}
				</DialogTitle>
				<DialogContent>
					{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}
				
					<Typography className={classes.selectedItemsDescription} variant="body1">
						{localize('subscription-confirm-choice-selected')}:
					</Typography>

					<List className={classes.selectedItemsList}>
						{listItems.map((item, index) => 
							(
								<ListItem key={`selected-item-${index+1}`} className={classes.selectedItemsListItem}>
									<Typography
										variant='p'
										className={classes.productTitle}
										dangerouslySetInnerHTML={{ __html: item }} />
								</ListItem>								
							)
						)}
					</List>

					<Grid item container direction="row" justify="flex-end">
						<Grid item>
							<Button
								variant='outlined'
								color='primary'
								data-role='outlined'
								data-tid="button-confirm-choice-modal-cancel"
								className={classNames(classes.button, classes.buttonCancel)}
								onClick={() => this.closeDialog()}
							>
								{localize('go-back')}
							</Button>
						</Grid>
						<Grid item>
							<Button
								variant='contained'
								color='primary'
								data-role='contained'
								data-tid="button-confirm-choice-modal-continue"
								className={classNames(classes.button, classes.buttonPrimary, classes.buttonContinue)}
								onClick={() => this.continueToCheckout()}
							>
								{localize('continue-to-checkout')}
							</Button>
						</Grid>
					</Grid>
				</DialogContent>
			</Fragment>
		);
	}

	closeDialog() {
		this.props.hideModal();
	}

	renderErrorMessage() {
		const errorMessage = _.get(this.state, 'errors.apiError');
		const { classes } = this.props;
		return (
			<Typography className={classes.errorMessage} variant="body2" dangerouslySetInnerHTML={{ __html: errorMessage }} />
		);		
	}	

	handleApiErrors(propsSource) {
		if (propsSource.companies.createChargeBeeSubscriptionErrorId) {
			const errorMessage = propsSource.companies.createChargeBeeSubscriptionErrorId &&
				errors[propsSource.companies.createChargeBeeSubscriptionErrorId] || 
				localize('subscriptions-error-unknown');

			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}	

	continueToCheckout() {
		this.setState({
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});		
		this.props.cb();
	}
}

ConfirmPurchaseChoiceModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	classes: PropTypes.object,
	listItems: PropTypes.array,
	plan: PropTypes.string,
	cb: PropTypes.func,
	company: PropTypes.object,
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	modalShown: state.modal.modalShown,
	companies: state.companies
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmPurchaseChoiceModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmPurchaseChoiceModal.js